module.exports = __webpack_public_path__ + "img/record-pause.05f31a42.png";